import { css } from 'lit';
export default css `
    .ripple {
        animation: ripple 1s forwards cubic-bezier(0, 0, 0.2, 1);
        background-color: rgba(255, 255, 255, 0.4);
    }

    @keyframes ripple {
        0% {
            transform: scale(0);
            opacity: 1;
        }
        80% {
            transform: scale(1);
        }
        100% {
            opacity: 0;
        }
    }
`;
